export default __webpack_public_path__ + "static/media/droid.1d5132f7.png";